import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    if (!session_id) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id }, { withCredentials: true });
        await refresh();
        navigate("/admin", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Login failed";
        setError(detail);
        setTimeout(() => navigate("/admin/login", { replace: true, state: { error: detail } }), 1800);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC]">
      <div className="rounded-lg border border-[#E2E8F0] bg-white p-10 text-center shadow-sm">
        <Loader2 size={28} className="mx-auto animate-spin text-[#E8772E]" />
        <p className="mt-4 font-serif-display text-2xl text-[#0A1128]">
          {error ? "Sign-in failed" : "Signing you in..."}
        </p>
        {error && <p className="mt-2 max-w-sm text-sm text-[#475569]">{error}</p>}
      </div>
    </div>
  );
}
